module.exports = __webpack_public_path__ + "media/images/health_banner-ce250853.svg";